import { deleteByKey } from '@/helpers/array';

const deleteFromStage = (stagesPricePlaces, data) => {
  const { stageId, itemId } = data;
  const result = { ...stagesPricePlaces };
  const items = result[stageId];

  const newItems = deleteByKey(items, itemId);
  result[stageId] = newItems;
  return result;
};

export default {
  namespaced: true,
  state: {
    eventPlaces: {},
    stagePricePlaces: {},
  },
  getters: {
    stagePricePlaces: (state) => state.stagePricePlaces || {},
  },
  actions: {
    setStagePricePlaces({ commit }, id) {
      commit('SET_STAGE_PRICE_PLACES', id);
    },
    cancelStageReward({ commit }, data) {
      commit('CANCEL_STAGE_REWARD', data);
    },
  },
  mutations: {
    SET_STAGE_PRICE_PLACES(state, data) {
      state.stagePricePlaces = { ...state.stagePricePlaces, ...data };
    },
    CANCEL_STAGE_REWARD(state, data) {
      state.stagePricePlaces = deleteFromStage(state.stagePricePlaces, data);
    },
  },
};
